/* Svante redesign (Boost My Store, Oct 2026). Vanilla JS, no dependencies. */
(function () {
  'use strict';
  var SV = (window.SV = window.SV || {});
  var CFG = window.SVCFG || {};
  var ROOT = (CFG.root || '/').replace(/\/$/, '');
  var COUNTRY = (CFG.country || 'US').toUpperCase();
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function lock(on) { document.documentElement.classList.toggle('sv-lock', !!on); }
  /* Open or close an overlay (menu, filters): screen-reader state, aria-expanded on its toggles, focus in and back out. */
  function overlay(el, on) {
    if (!el) return;
    el.classList.toggle('is-open', !!on); el.setAttribute('aria-hidden', on ? 'false' : 'true'); lock(on);
    $$('[aria-controls="' + el.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', on ? 'true' : 'false'); });
    if (on) {
      el._opener = document.activeElement;
      setTimeout(function () { var f = el.querySelector('[role="dialog"] button'); f && f.focus({ preventScroll: true }); }, 60);
    } else if (el._opener) { try { el._opener.focus({ preventScroll: true }); } catch (x) {} el._opener = null; }
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* Money: the Liquid-rendered sample tells us the presentment currency format */
  SV.money = function (cents) {
    var sample = CFG.moneySample || '${{amount}}';
    var v = (Number(cents) || 0) / 100;
    var parts = v.toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var amt = parts.join('.');
    if (sample.indexOf('{{amount}}') > -1) return sample.replace('{{amount}}', amt);
    return sample.replace('123,456.78', amt);
  };
  SV.moneyShort = function (cents) { return SV.money(cents).replace(/\.00(?=\D*$)/, ''); };

  /* Sizes: age to US size, heights from Svante's own size chart */
  var US = { '4-5': 'US 4-5', '6-7': 'US 6-7', '8-9': 'US 8', '10-11': 'US 10', '12-13': 'US 12-14', '14-15': 'US 16-18' };
  var IN = { '4-5': '41-44 in', '6-7': '44-49 in', '8-9': '49-54 in', '10-11': '54-59 in', '12-13': '59-63 in', '14-15': '63-68 in' };
  var CM = { '4-5': '105-113 cm', '6-7': '114-125 cm', '8-9': '126-137 cm', '10-11': '138-149 cm', '12-13': '150-161 cm', '14-15': '162-173 cm' };
  SV.sizeSub = function (age) { return COUNTRY === 'GB' ? (CM[age] || '') : (US[age] || ''); };
  SV.sizeLabel = function (age) { return COUNTRY === 'GB' ? 'Age ' + age : 'Age ' + age + (US[age] ? ' (' + US[age] + ')' : ''); };
  SV.heightNote = function (age) {
    if (!IN[age]) return '';
    return COUNTRY === 'GB' ? 'Age ' + age + ' fits children ' + CM[age] + ' (' + IN[age] + ') tall.' : 'Age ' + age + ' fits children ' + IN[age] + ' (' + CM[age] + ') tall.';
  };

  /* ---------- CART DRAWER ---------- */
  SV.cart = {
    el: function () { return $('#sv-cart'); },
    page: function () { return $('[data-sv-cartpage]'); },
    open: function () {
      var el = this.el(); if (!el || this.page()) return;
      el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false'); lock(true);
      setTimeout(function () { var b = el.querySelector('[data-sv-cart-close]'); b && b.focus({ preventScroll: true }); }, 60);
    },
    close: function () {
      var el = this.el(); if (!el) return;
      el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true'); lock(false);
    },
    busy: function (on) {
      var el = this.el(); el && el.classList.toggle('is-busy', !!on);
      var pg = this.page(); pg && pg.classList.toggle('is-busy', !!on);
    },
    refresh: function () {
      var self = this, pg = self.page(), sid = pg && pg.getAttribute('data-section');
      var url = sid ? ROOT + '/cart?sections=sv-cart-drawer,' + sid : ROOT + '/?sections=sv-cart-drawer';
      return fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          if (sid && j[sid]) {
            var pdoc = new DOMParser().parseFromString(j[sid], 'text/html');
            var pfresh = pdoc.querySelector('[data-sv-cartpage]');
            if (pfresh) { pg.innerHTML = pfresh.innerHTML; }
          }
          var html = j['sv-cart-drawer']; if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('#sv-cart'); var cur = self.el();
          if (!fresh || !cur) return;
          cur.querySelector('.sv-cart__panel').innerHTML = fresh.querySelector('.sv-cart__panel').innerHTML;
          var n = fresh.getAttribute('data-count') || '0';
          cur.setAttribute('data-count', n);
          $$('[data-sv-cart-count]').forEach(function (b) { b.textContent = n; b.setAttribute('data-count', n); });
          SV.eta();
        });
    },
    add: function (items) {
      var self = this; self.busy(true);
      return fetch(ROOT + '/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function (j) { return self.refresh().then(function () { self.open(); return j; }); })
        .finally(function () { self.busy(false); });
    },
    change: function (key, qty) {
      var self = this; self.busy(true);
      return fetch(ROOT + '/cart/change.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function () { return self.refresh(); }).finally(function () { self.busy(false); });
    },
    note: function (text) {
      return fetch(ROOT + '/cart/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: text })
      });
    }
  };

  /* ---------- DELIVERY ESTIMATE: 1pm UK cut-off, US 4-12 days, UK 1-3 days ---------- */
  SV.eta = function () {
    var nodes = $$('[data-sv-eta]'); if (!nodes.length) return;
    var now = new Date();
    var ukParts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', hour: 'numeric', minute: 'numeric', weekday: 'short', hour12: false }).formatToParts(now);
    var get = function (t) { var p = ukParts.find(function (x) { return x.type === t; }); return p ? p.value : ''; };
    var h = parseInt(get('hour'), 10) % 24, m = parseInt(get('minute'), 10), wd = get('weekday');
    var weekend = wd === 'Sat' || wd === 'Sun';
    var beforeCut = !weekend && (h < 13);
    var mins = beforeCut ? (13 * 60) - (h * 60 + m) : 0;
    var shipOffset = 0; // days until it ships
    if (!beforeCut) { shipOffset = wd === 'Fri' ? 3 : wd === 'Sat' ? 2 : 1; }
    var range = COUNTRY === 'US' ? [4, 12] : COUNTRY === 'GB' ? [1, 3] : null;
    var locale = COUNTRY === 'GB' ? 'en-GB' : 'en-US';
    var fmt = function (d) { return d.toLocaleDateString(locale, { month: 'short', day: 'numeric' }); };
    var lead = beforeCut ? ('Order within ' + (mins >= 60 ? Math.floor(mins / 60) + ' hr' + (Math.floor(mins / 60) > 1 ? 's' : '') : mins + ' min') + ', ships today.') : (shipOffset === 1 ? 'Ships tomorrow.' : 'Ships Monday.');
    var tail = '';
    if (range) {
      var a = new Date(now.getTime() + (shipOffset + range[0]) * 864e5), b = new Date(now.getTime() + (shipOffset + range[1]) * 864e5);
      tail = ' Arrives ' + fmt(a) + ' - ' + fmt(b) + (COUNTRY === 'US' ? ' in the US.' : '.');
    } else { tail = ' Ships worldwide from the UK.'; }
    nodes.forEach(function (n) {
      if (n.hasAttribute('data-sv-eta-short')) { n.innerHTML = esc(lead + tail); }
      else { n.innerHTML = '<b>' + esc(lead) + '</b>' + esc(tail); }
    });
  };

  /* ---------- OPTION PICKER (PDP and quick add) ---------- */
  function isSizeOpt(o) { return /age|size/i.test(o.name || ''); }
  function isColourOpt(o) { return /colou?r/i.test(o.name || ''); }
  function pieceLabel(name) {
    var n = (name || '').toLowerCase();
    if (n.indexOf('hood') > -1) return 'Hoodie';
    if (n.indexOf('jogger') > -1) return 'Joggers';
    if (n.indexOf('legging') > -1) return 'Leggings';
    if (n.indexOf('crop') > -1 && n.indexOf('t-shirt') === -1 && n.indexOf('tee') === -1) return 'Crop top';
    if (n.indexOf('t-shirt') > -1 || n.indexOf('tee') > -1 || n.indexOf('top') > -1) return 'Tee';
    if (n.indexOf('short') > -1) return 'Shorts';
    return (name || '').split('|')[0].trim();
  }
  SV.pieceLabel = pieceLabel;

  function Picker(root, product) {
    this.root = root; this.p = product;
    var opts = (product.options || []).map(function (o, i) {
      return typeof o === 'string' ? { name: o, position: i + 1, values: uniq(product.variants.map(function (v) { return v.options[i]; })) } : o;
    });
    this.opts = opts;
    this.sizeIdx = []; this.colourIdx = -1;
    var self = this;
    opts.forEach(function (o, i) { if (isColourOpt(o)) self.colourIdx = i; else if (isSizeOpt(o)) self.sizeIdx.push(i); });
    this.isSet = this.sizeIdx.length >= 2;
    this.same = true;
    this.sel = opts.map(function () { return null; });
    if (this.colourIdx > -1) {
      var init = root.getAttribute('data-colour') || '';
      var pre = product.variants.find(function (v) { return v.available && (!init || v.options[self.colourIdx] === init); }) || product.variants[0];
      this.sel[this.colourIdx] = init || pre.options[this.colourIdx];
    }
    opts.forEach(function (o, i) { if (o.values.length === 1) self.sel[i] = o.values[0]; });
    var pre2 = root.getAttribute('data-variant');
    if (pre2) { var v = product.variants.find(function (x) { return String(x.id) === pre2; }); if (v) self.sel = v.options.slice(); }
    this.onChange = function () {};
    this.bind(); this.sync();
  }
  function uniq(a) { return a.filter(function (x, i) { return a.indexOf(x) === i; }); }
  Picker.prototype.variant = function () {
    var s = this.sel;
    if (s.some(function (x) { return x == null; })) return null;
    return this.p.variants.find(function (v) { return v.options.every(function (o, i) { return o === s[i]; }); }) || null;
  };
  Picker.prototype.availableFor = function (idx, val) {
    var s = this.sel.slice();
    s[idx] = val;
    if (this.isSet && this.same) { this.sizeIdx.forEach(function (i) { s[i] = val; }); }
    return this.p.variants.some(function (v) {
      return v.available && v.options.every(function (o, i) { return s[i] == null || o === s[i]; });
    });
  };
  Picker.prototype.bind = function () {
    var self = this;
    this.root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-sv-val]'); if (!b || !self.root.contains(b)) return;
      e.preventDefault();
      var idx = parseInt(b.getAttribute('data-sv-idx'), 10), val = b.getAttribute('data-sv-val');
      if (self.isSet && self.same && self.sizeIdx.indexOf(idx) > -1) { self.sizeIdx.forEach(function (i) { self.sel[i] = val; }); }
      else { self.sel[idx] = val; }
      self.sync(true);
    });
    var same = this.root.querySelector('[data-sv-same]');
    if (same) same.addEventListener('change', function () {
      self.same = same.checked;
      if (self.same) { var first = self.sel[self.sizeIdx[0]]; self.sizeIdx.forEach(function (i) { self.sel[i] = first; }); }
      self.sync(true);
    });
  };
  Picker.prototype.sync = function (user) {
    var self = this, root = this.root;
    $$('[data-sv-idx]', root).forEach(function (b) {
      var idx = parseInt(b.getAttribute('data-sv-idx'), 10), val = b.getAttribute('data-sv-val');
      var on = self.sel[idx] === val;
      b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (idx !== self.colourIdx) b.classList.toggle('is-out', !self.availableFor(idx, val));
    });
    var rowB = root.querySelector('[data-sv-rowb]');
    if (rowB) rowB.hidden = this.same;
    var lblA = root.querySelector('[data-sv-lbla]');
    if (lblA && this.isSet) lblA.textContent = this.same ? 'Size' : pieceLabel(this.opts[this.sizeIdx[0]].name) + ' size';
    var age = this.sizeIdx.length ? this.sel[this.sizeIdx[0]] : null;
    var sl = root.querySelector('[data-sv-sizesel]'); if (sl) sl.textContent = age ? SV.sizeLabel(age) : 'Choose an age';
    var hn = root.querySelector('[data-sv-hnote]'); if (hn) hn.textContent = age ? SV.heightNote(age) : '';
    if (this.colourIdx > -1) { var cn = root.querySelector('[data-sv-colname]'); if (cn) cn.textContent = this.sel[this.colourIdx] || ''; }
    this.onChange(this.variant(), user);
  };
  SV.Picker = Picker;

  function pickerHTML(p, opts) {
    var sizeIdx = [], colourIdx = -1, html = '';
    p.options.forEach(function (o, i) { if (isColourOpt(o)) colourIdx = i; else if (isSizeOpt(o)) sizeIdx.push(i); });
    if (colourIdx > -1 && p.options[colourIdx].values.length > 1) {
      html += '<div class="sv-opt"><div class="sv-lbl"><span>Colour: <b data-sv-colname></b></span></div><div class="sv-sw">' +
        p.options[colourIdx].values.map(function (v) { return '<button type="button" data-sv-idx="' + colourIdx + '" data-sv-val="' + esc(v) + '" title="' + esc(v) + '" style="background:' + (opts.hex[v.toLowerCase()] || '#d8d8d6') + '" aria-label="' + esc(v) + '"></button>'; }).join('') + '</div></div>';
    }
    p.options.forEach(function (o, i) {
      if (i === colourIdx || sizeIdx.indexOf(i) > -1 || o.values.length < 2) return;
      html += '<div class="sv-opt"><div class="sv-lbl"><span>' + esc(o.name) + '</span></div><div class="sv-sizes">' +
        o.values.map(function (v) { return '<button type="button" data-sv-idx="' + i + '" data-sv-val="' + esc(v) + '"><b>' + esc(v) + '</b></button>'; }).join('') + '</div></div>';
    });
    var row = function (i) { return '<div class="sv-sizes">' + p.options[i].values.map(function (v) { return '<button type="button" data-sv-idx="' + i + '" data-sv-val="' + esc(v) + '"><b>' + esc(v) + '</b><small>' + esc(SV.sizeSub(v)) + '</small></button>'; }).join('') + '</div>'; };
    if (sizeIdx.length) {
      html += '<div class="sv-opt"><div class="sv-lbl"><span><span data-sv-lbla>Size</span>: <b data-sv-sizesel>Choose an age</b></span></div>' + row(sizeIdx[0]);
      if (sizeIdx.length > 1) {
        html += '<div data-sv-rowb hidden><div class="sv-lbl" style="margin:10px 0 8px"><span>' + esc(pieceLabel(p.options[sizeIdx[1]].name)) + ' size</span></div>' + row(sizeIdx[1]) + '</div>';
        html += '<label class="sv-same"><input type="checkbox" data-sv-same checked><span class="sv-same__box">&#10003;</span>Same size for ' + esc(pieceLabel(p.options[sizeIdx[0]].name).toLowerCase()) + ' and ' + esc(pieceLabel(p.options[sizeIdx[1]].name).toLowerCase()) + '</label>';
      }
      html += '<div class="sv-hnote" data-sv-hnote></div></div>';
    }
    return html;
  }

  /* ---------- QUICK ADD SHEET ---------- */
  var HEX = { 'peacoat blue': '#2c3445', 'navy': '#2c3445', 'harbour mist': '#cfd2d3', 'grey': '#cfd2d3', 'blue': '#7fa6d8', 'taupe pink': '#d9b9a8', 'pink': '#e9c7c0', 'cream': '#efe6d6', 'white': '#f7f6f2', 'optic white': '#f7f6f2', 'black': '#2b2923', 'glacial blue': '#a9cdea' };
  SV.quickAdd = function (handle, btn) {
    var sheet = $('#sv-qs'); if (!sheet) return;
    btn && btn.setAttribute('aria-busy', 'true');
    fetch(ROOT + '/products/' + handle + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (p) {
      p.options = p.options.map(function (o) { return typeof o === 'string' ? { name: o } : o; });
      p.options.forEach(function (o, i) { if (!o.values) o.values = uniq(p.variants.map(function (v) { return v.options[i]; })); });
      var card = btn && btn.closest('.sv-card, .sv-mi, .sv-up__it');
      var img = card && card.querySelector('img');
      var title = (btn && btn.dataset.title) || p.title.split('|')[0];
      var imgSrc = img ? (img.currentSrc || img.src) : (p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '');
      var body = sheet.querySelector('.sv-qs__panel');
      body.innerHTML = '<div class="sv-qs__top">' + (imgSrc ? '<img src="' + esc(imgSrc) + '" alt="">' : '<span></span>') +
        '<div><b class="sv-h3" style="display:block">' + esc(title) + '</b><span class="sv-small sv-muted">' + SV.money(p.price) + '</span></div>' +
        '<button type="button" data-sv-qs-close aria-label="Close">' + SV.icon('x') + '</button></div>' +
        '<div class="sv-picker" data-sv-qs-picker>' + pickerHTML(p, { hex: HEX }) + '</div>' +
        '<button type="button" class="sv-btn sv-btn--cta sv-btn--block" data-sv-qs-add disabled>Choose a size</button>' +
        '<p class="sv-err" data-sv-qs-err></p>' +
        '<a class="sv-link" href="' + esc(p.url) + '" style="justify-self:start">View full details</a>';
      body.style.display = 'grid';
      var picker = new Picker(body.querySelector('[data-sv-qs-picker]'), p);
      var add = body.querySelector('[data-sv-qs-add]');
      picker.onChange = function (v) {
        if (!v) { add.disabled = false; add.textContent = 'Choose a size'; add.dataset.id = ''; return; }
        add.disabled = !v.available; add.dataset.id = v.id;
        add.textContent = v.available ? 'Add to bag · ' + SV.money(v.price) : 'Sold out';
      };
      picker.sync();
      add.addEventListener('click', function () {
        if (!add.dataset.id) { var s = body.querySelector('.sv-sizes'); s && (s.classList.remove('is-alert'), void s.offsetWidth, s.classList.add('is-alert')); return; }
        add.disabled = true;
        var qi = { id: Number(add.dataset.id), quantity: 1 };
        if (btn && btn.hasAttribute('data-preorder')) qi.properties = { 'Pre-order': 'Ships when the new stock arrives' };
        SV.cart.add([qi]).then(function () { SV.closeSheet(); })
          .catch(function (err) { var e = body.querySelector('[data-sv-qs-err]'); e.textContent = (err && (err.description || err.message)) || 'Something went wrong.'; e.classList.add('is-on'); add.disabled = false; });
      });
      sheet.classList.add('is-open'); lock(true);
    }).finally(function () { btn && btn.removeAttribute('aria-busy'); });
  };
  SV.closeSheet = function () { var s = $('#sv-qs'); if (s) { s.classList.remove('is-open'); } if (!$('#sv-cart.is-open')) lock(false); };
  SV.icon = function (n) {
    var p = { x: '<path d="M6 6l12 12M18 6L6 18"/>', plus: '<path d="M12 5v14M5 12h14"/>' }[n] || '';
    return '<svg class="sv-i" viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true">' + p + '</svg>';
  };

  /* ---------- PRODUCT PAGE ---------- */
  function initPDP() {
    var wrap = $('[data-sv-pdp]'); if (!wrap) return;
    var data = JSON.parse(($('#sv-product-json') || {}).textContent || 'null'); if (!data) return;
    var pickerEl = wrap.querySelector('[data-sv-picker]');
    var atc = wrap.querySelector('[data-sv-atc]');
    var stickyBtn = $('[data-sv-sticky-atc]');
    var stickyInfo = $('[data-sv-sticky-info]');
    var bis = wrap.querySelector('[data-sv-bis]');
    var err = wrap.querySelector('[data-sv-err]');
    var pay = wrap.querySelector('[data-sv-pay]');
    var picker = new Picker(pickerEl, data);
    var colourIdx = picker.colourIdx;
    function label(v) {
      if (!v) return atc.dataset.choose || 'Choose a size';
      return v.available ? (atc.hasAttribute('data-preorder') ? 'Pre-order · ' : 'Add to bag · ') + SV.money(v.price) : 'Sold out';
    }
    picker.onChange = function (v, user) {
      atc.textContent = label(v); atc.disabled = !!(v && !v.available);
      if (stickyBtn) { stickyBtn.textContent = v ? (v.available ? 'Add to bag' : 'Sold out') : (picker.sizeIdx.length ? 'Choose size' : 'Choose'); stickyBtn.disabled = !!(v && !v.available); }
      if (bis) bis.hidden = !(v && !v.available);
      if (pay) { pay.hidden = !!(v && !v.available); if (v) pay.textContent = 'Or 3 payments of ' + SV.money(Math.ceil(v.price / 3)) + ' with Klarna or Shop Pay'; }
      if (stickyInfo) {
        var bits = [];
        if (colourIdx > -1 && picker.sel[colourIdx]) bits.push(picker.sel[colourIdx]); else if (stickyInfo.dataset.colour) bits.push(stickyInfo.dataset.colour);
        if (picker.sizeIdx.length && picker.sel[picker.sizeIdx[0]]) bits.push('Age ' + picker.sel[picker.sizeIdx[0]]);
        bits.push(SV.money(v ? v.price : data.price));
        stickyInfo.querySelector('span').textContent = bits.join(' · ');
      }
      if (err) err.classList.remove('is-on');
      if (user && v) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); }
      if (colourIdx > -1) filterGallery(picker.sel[colourIdx]);
    };
    picker.sync();
    function nudge() {
      var s = pickerEl.querySelector('.sv-sizes'); if (!s) return;
      s.scrollIntoView({ behavior: 'smooth', block: 'center' });
      s.classList.remove('is-alert'); void s.offsetWidth; s.classList.add('is-alert');
    }
    function addNow() {
      var v = picker.variant();
      if (!v) { nudge(); return; }
      if (!v.available) return;
      atc.disabled = true; if (stickyBtn) stickyBtn.disabled = true;
      var item = { id: v.id, quantity: 1 };
      if (atc.hasAttribute('data-preorder')) item.properties = { 'Pre-order': 'Ships when the new stock arrives' };
      SV.cart.add([item]).catch(function (e) {
        if (err) { err.textContent = (e && (e.description || e.message)) || 'Sorry, that did not work. Please try again.'; err.classList.add('is-on'); }
      }).finally(function () { atc.disabled = false; if (stickyBtn) stickyBtn.disabled = false; picker.sync(); });
    }
    atc.addEventListener('click', addNow);
    stickyBtn && stickyBtn.addEventListener('click', addNow);
    // Sticky bar: hide while the main button is on screen
    var sticky = $('[data-sv-sticky]');
    if (sticky && 'IntersectionObserver' in window) {
      document.body.classList.add('sv-has-sticky');
      new IntersectionObserver(function (en) { sticky.classList.toggle('is-hidden', en[0].isIntersecting); }, { threshold: 0.1 }).observe(atc);
    }
    // Gallery
    var gal = wrap.querySelector('[data-sv-gal]');
    var thumbs = $$('[data-sv-thumb]', wrap);
    // Desktop grid shows the first 8 photos of the chosen colour; hidden colours do not count
    function capGallery() {
      if (!gal) return;
      var n = 0;
      $$('.sv-gal__it', gal).forEach(function (it) {
        var over = !it.classList.contains('is-hidden') && ++n > 8;
        it.classList.toggle('is-over', over);
      });
    }
    function filterGallery(colour) {
      if (!gal || !colour) return;
      var slug = colour.toLowerCase().replace(/[^a-z0-9]+/g, '-');
      var items = $$('.sv-gal__it', gal);
      var tagged = items.some(function (it) { return it.dataset.colour; });
      if (!tagged) return;
      var shown = 0;
      items.forEach(function (it, i) {
        var hide = it.dataset.colour && it.dataset.colour !== slug;
        it.classList.toggle('is-hidden', !!hide);
        if (thumbs[i]) thumbs[i].classList.toggle('is-hidden', !!hide);
        if (!hide && shown++ < 4) { var im = it.querySelector('img[loading="lazy"]'); if (im) im.loading = 'eager'; }
      });
      capGallery();
      gal.scrollTo({ left: 0 });
    }
    capGallery();
    if (gal) {
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var it = gal.querySelectorAll('.sv-gal__it')[parseInt(t.dataset.svThumb, 10)];
          if (it) gal.scrollTo({ left: it.offsetLeft - gal.offsetLeft, behavior: 'smooth' });
        });
      });
      var ticking = false;
      gal.addEventListener('scroll', function () {
        if (ticking) return; ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          var items = $$('.sv-gal__it', gal), best = 0, bd = 1e9;
          items.forEach(function (it, i) { if (it.classList.contains('is-hidden')) return; var d = Math.abs(it.offsetLeft - gal.offsetLeft - gal.scrollLeft); if (d < bd) { bd = d; best = i; } });
          thumbs.forEach(function (t, i) { t.classList.toggle('is-on', i === best); });
        });
      }, { passive: true });
    }
    // Wear it with: one-tap add opens the quick-add sheet for size
    $$('[data-sv-mini]', wrap).forEach(function (b) { b.addEventListener('click', function () { SV.quickAdd(b.dataset.svMini, b); }); });
  }

  /* ---------- ACCORDIONS: one open at a time per group (native name attr, with a fallback) ---------- */
  document.addEventListener('toggle', function (e) {
    var d = e.target, n = d && d.tagName === 'DETAILS' && d.open && d.getAttribute('name');
    if (!n) return;
    $$('details[name="' + n + '"]').forEach(function (x) { if (x !== d && x.open) x.open = false; });
  }, true);

  /* ---------- CARD COLOUR SWATCHES ---------- */
  function cardSwatch(b) {
    var card = b.closest('.sv-card'); if (!card) return;
    var img = card.querySelector('.sv-card__pic img');
    if (img && b.dataset.src) { img.srcset = b.dataset.srcset || ''; img.src = b.dataset.src; }
    if (b.dataset.url) $$('a.sv-card__pic, a.sv-card__meta', card).forEach(function (a) { a.href = b.dataset.url; });
    $$('.sv-card__sw button', card).forEach(function (x) { var on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
  }
  document.addEventListener('click', function (e) { var b = e.target.closest && e.target.closest('div.sv-card__sw button'); if (b) { e.preventDefault(); cardSwatch(b); } });
  if (window.matchMedia && matchMedia('(hover:hover)').matches) document.addEventListener('mouseover', function (e) { var b = e.target.closest && e.target.closest('div.sv-card__sw button'); if (b && !b.classList.contains('is-on')) cardSwatch(b); });

  /* ---------- RECOMMENDATIONS ---------- */
  function initRecs() {
    $$('[data-sv-recs]').forEach(function (el) {
      fetch(el.dataset.url, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (t) {
        var doc = new DOMParser().parseFromString(t, 'text/html');
        var n = doc.querySelector('[data-sv-recs]');
        if (n && n.querySelector('.sv-card')) el.innerHTML = n.innerHTML; else el.closest('.shopify-section') && (el.closest('.shopify-section').style.display = 'none');
      });
    });
  }

  /* ---------- COLLECTION ---------- */
  function initCollection() {
    $$('[data-sv-subtab]').forEach(function (b) {
      b.addEventListener('click', function () {
        var k = b.dataset.svSubtab, box = b.closest('.sv-subnav');
        $$('[data-sv-subtab]', box).forEach(function (x) { x.classList.toggle('is-on', x === b); });
        $$('[data-sv-tiles]', box).forEach(function (x) { x.classList.toggle('is-on', x.dataset.svTiles === k); });
      });
    });
    var fd = $('#sv-fd');
    $$('[data-sv-fd-open]').forEach(function (b) { b.addEventListener('click', function () { if (!fd) return; overlay(fd, true); var g = b.dataset.svFdOpen && fd.querySelector('[data-sv-fgrp="' + b.dataset.svFdOpen + '"]'); if (g) g.scrollIntoView({ block: 'start' }); }); });
    $$('[data-sv-fd-close]').forEach(function (b) { b.addEventListener('click', function () { overlay(fd, false); }); });
    var sort = $('[data-sv-sort]');
    sort && sort.addEventListener('change', function () { var u = new URL(location.href); u.searchParams.set('sort_by', sort.value); u.searchParams.delete('page'); location.href = u.toString(); });
    $$('[data-sv-more]').forEach(function (b) {
      b.addEventListener('click', function () {
        var url = b.dataset.next; if (!url) return;
        b.disabled = true; b.textContent = 'Loading…';
        fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (t) {
          var doc = new DOMParser().parseFromString(t, 'text/html');
          var grid = $('[data-sv-grid]'), ng = doc.querySelector('[data-sv-grid]');
          if (grid && ng) $$('.sv-card', ng).forEach(function (c) { grid.appendChild(c); });
          var nb = doc.querySelector('[data-sv-more]');
          if (nb && nb.dataset.next) { b.dataset.next = nb.dataset.next; b.disabled = false; b.textContent = nb.textContent; } else { b.parentNode.remove(); }
        });
      });
    });
  }

  /* ---------- TABS on rails (All / Girls / Boys) ---------- */
  function initTabs() {
    $$('[data-sv-tabs]').forEach(function (tabs) {
      var rail = document.getElementById(tabs.dataset.svTabs); if (!rail) return;
      $$('button', tabs).forEach(function (b) {
        b.addEventListener('click', function () {
          $$('button', tabs).forEach(function (x) { x.classList.toggle('is-on', x === b); x.setAttribute('aria-pressed', x === b); });
          var f = b.dataset.filter;
          $$('.sv-card', rail).forEach(function (c) { c.style.display = (f === 'all' || c.dataset.gender === f) ? '' : 'none'; });
          rail.scrollTo({ left: 0 });
        });
      });
    });
  }

  /* ---------- HEADER: mobile drawer ---------- */
  function initHeader() {
    var d = $('#sv-drawer');
    $$('[data-sv-menu-open]').forEach(function (b) { b.addEventListener('click', function () { overlay(d, true); }); });
    $$('[data-sv-menu-close]').forEach(function (b) { b.addEventListener('click', function () { overlay(d, false); }); });
    $$('[data-sv-seg]').forEach(function (b) {
      b.addEventListener('click', function () {
        var k = b.dataset.svSeg;
        $$('[data-sv-seg]').forEach(function (x) { x.classList.toggle('is-on', x === b); });
        $$('[data-sv-pane]').forEach(function (x) { x.classList.toggle('is-on', x.dataset.svPane === k); });
      });
    });
  }

  /* ---------- GLOBAL DELEGATION ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var o = t.closest('[data-sv-cart-open]'); if (o) { e.preventDefault(); SV.cart.refresh(); SV.cart.open(); return; }
    if (t.closest('[data-sv-cart-close]')) { e.preventDefault(); SV.cart.close(); return; }
    var q = t.closest('[data-sv-qty]'); if (q) { e.preventDefault(); SV.cart.change(q.dataset.key, parseInt(q.dataset.svQty, 10)); return; }
    var up = t.closest('[data-sv-up-add]'); if (up) { e.preventDefault(); up.disabled = true; SV.cart.add([{ id: Number(up.dataset.svUpAdd), quantity: 1 }]); return; }
    var qa = t.closest('[data-sv-qa]'); if (qa) { e.preventDefault(); SV.quickAdd(qa.dataset.svQa, qa); return; }
    if (t.closest('[data-sv-qs-close]')) { e.preventDefault(); SV.closeSheet(); return; }
  });
  document.addEventListener('change', function (e) {
    var n = e.target.closest('[data-sv-note]'); if (n) SV.cart.note(n.value);
    var loc = e.target.closest('[data-sv-loc]'); if (loc) loc.form.submit();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    SV.cart.close(); SV.closeSheet();
    var d = $('#sv-drawer.is-open'); if (d) overlay(d, false);
    var f = $('#sv-fd.is-open'); if (f) overlay(f, false);
  });

  document.addEventListener('eurus:cart:items-changed', function () { SV.cart.refresh().then(function () { SV.cart.open(); }); });

  function init() { initHeader(); initTabs(); initCollection(); initPDP(); initRecs(); SV.eta(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
